module.exports = __webpack_public_path__ + "img/bg4.ecdb33dc.png";